import { Box } from "@mui/material";
import clsx from "clsx";
import { useContext } from "react";
import { useAppStore } from "../../../../../../hooks/useStores.tsx";
import { DesignEditorContext } from "../../../../../contexts/DesignEditor.tsx";
import { useActiveObject } from "../../../../../hooks/useActiveObject.tsx";
import EditAllAdsSwitch from "../../Panels/panelItems/Common/EditAllAdsSwitch/EditAllAdsSwitch";
import FabricObjectsProperties from "../../Panels/panelItems/Common/FabricObjectsProperties/FabricObjectsProperties.tsx";
import Flip from "../Shared/Flip/Flip";
import styles from "./Image.module.scss";
import ImageAlignment from "./ImageAlignment/ImageAlignment.tsx";
export default function () {
	const { isPopupView } = useContext(DesignEditorContext);
	const { uiStore } = useAppStore();
	const activeObject = useActiveObject() as Required<fabric.Object>;

	return (
		<Box
			className={clsx({
				[styles.container]: true,
				[styles.hide]: isPopupView,
			})}
		>
			<Box
				className={clsx({
					[styles.imageToolBar]: true,
					[styles.noMarginRight]: uiStore.showGuideSection,
				})}
			>
				<Box className={styles.imageControlIcons}>
					<Flip />
					{activeObject?.isLogo && <ImageAlignment />}
					<FabricObjectsProperties />
				</Box>
				<EditAllAdsSwitch />
			</Box>
		</Box>
	);
}
